import type { OfflineItemRow } from '../../mobilecompanion/framework';

type Props = { items?: OfflineItemRow[] };

export function OfflineExperiencePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.title} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{item.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{item.feature} · {item.size}</p>
          </div>
          <p className="shrink-0 text-xs text-slate-500">{item.updated}</p>
        </div>
      ))}
    </div>
  );
}
